// เสียง/แสง/สั่น ตอนยิงติด — บน iOS พึ่งได้แค่ "แสง" อย่างเดียว 100%
//   · เสียง: ปุ่มปิดเสียงข้างเครื่องปิดได้ (แก้ด้วย audioSession = 'playback')
//   · สั่น: navigator.vibrate ไม่เคยมีบน iOS และ Apple อุดทางลัดที่เคยใช้ได้แล้ว
// เพราะงั้นแฟลชเต็มจอ + ชื่อสินค้าตัวใหญ่คือตัวยืนยันหลัก
let audioCtx = null;

/** ต้องเรียกจาก gesture เดียวกับที่เปิดกล้อง ไม่งั้น AudioContext ค้างที่ suspended */
export function unlockAudio() {
  try { if (navigator.audioSession) navigator.audioSession.type = 'playback'; } catch { /* Safari < 16.4 */ }
  try {
    if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    if (audioCtx.state === 'suspended') audioCtx.resume();
  } catch { audioCtx = null; }
}

export function beep({ freq = 2000, ms = 70, gain = 0.25 } = {}) {
  if (!audioCtx) return;
  try {
    const t = audioCtx.currentTime;
    const osc = audioCtx.createOscillator(), g = audioCtx.createGain();
    osc.type = 'square';
    osc.frequency.value = freq;
    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(gain, t + 0.005);
    g.gain.exponentialRampToValueAtTime(0.0001, t + ms / 1000);
    osc.connect(g).connect(audioCtx.destination);
    osc.start(t);
    osc.stop(t + ms / 1000 + 0.02);
  } catch { /* ปิดเสียงอยู่ */ }
}

export const beepOk = () => beep({ freq: 2000, ms: 60 });
export const beepUnknown = () => { beep({ freq: 700, ms: 90 }); setTimeout(() => beep({ freq: 520, ms: 120 }), 110); };

/** ได้จริงบน Android, บน iOS เงียบ — ห้ามให้ UX ไปพึ่งอันนี้ */
export function haptic() { try { navigator.vibrate?.(30); } catch { /* ignore */ } }

/**
 * ล็อกหน้าจอไม่ให้หมุนตามเครื่อง
 * ⚠️ Safari บน iOS ไม่รองรับ screen.orientation.lock (Android/Chrome รองรับเฉพาะตอน fullscreen)
 * บน iPhone ต้องล็อกจาก Control Center → ปุ่มล็อกแนวตั้ง ถึงจะได้ผลจริง
 * ฟังก์ชันนี้เลยเป็น best-effort: ได้ก็ดี ไม่ได้ก็ไม่พัง — และหน้าสแกนอ่านป้ายตะแคงได้อยู่แล้ว
 * เลยไม่ต้องเอียงเครื่องตั้งแต่แรก
 */
export async function tryLockPortrait() {
  try { await screen.orientation?.lock?.('portrait'); return true; } catch { return false; }
}
export function unlockOrientation() {
  try { screen.orientation?.unlock?.(); } catch { /* ไม่รองรับ */ }
}

let wakeLock = null;
export async function acquireWakeLock() {
  try { wakeLock = (await navigator.wakeLock?.request('screen')) ?? null; } catch { wakeLock = null; }
}
export function releaseWakeLock() {
  try { wakeLock?.release(); } catch { /* ignore */ }
  wakeLock = null;
}
